import { render, staticRenderFns } from "./LeftArrowIcon.vue?vue&type=template&id=060e8b0e"
var script = {}


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/html/brkt/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('060e8b0e')) {
      api.createRecord('060e8b0e', component.options)
    } else {
      api.reload('060e8b0e', component.options)
    }
    module.hot.accept("./LeftArrowIcon.vue?vue&type=template&id=060e8b0e", function () {
      api.rerender('060e8b0e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/libs/lightbox/LeftArrowIcon.vue"
export default component.exports